export default __webpack_public_path__ + "static/hiv-rapid-start-2d48882e193dc3153f2446d1a4dd07b1.svg";